import { render, staticRenderFns } from "./1317_将整数转换为两个无零整数的和.md?vue&type=template&id=b8880cc8&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports